export default __webpack_public_path__ + "static/media/location-dot-solid.5bf13282.svg";